import { AlignLeft } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function ExtractText() {
  const { t } = useLanguage();
  const tk = t.tools.extractText;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/extract-text",
    accept: ".pdf",
    multiple: false,
    resultType: "text",
    resultFileName: tk.result,
    color: "#0284c7",
    Icon: AlignLeft,
    toolKey: "extractText",
    pagesLabel: tk.pagesLabel,
    copyLabel: tk.copyText,
    downloadTxtLabel: tk.downloadTxt,
  };

  return <ToolPage config={config} />;
}
